

/* eslint-disable angular/typecheck-string */

/**
 * add non empty key, value to the object
 * @param {Object} object where to add new key, value
 * @param {String} key
 * @param {Any type} value, can not be empty
 * @returns {void}
*/

module.exports = {
    addValidParam: function addValidParam(obj, key, val) {
        if (!obj) {
            return;
        }
        if (typeof key === 'string' && key && val !== undefined && val !== null) {
            obj[key] = val;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/utils/index.js
// module id = ./components/xo-page-components/src/utils/index.js
// module chunks = 1